/**
 * Dealflow Deck API
 * API to by used by deck
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

export type AnswerTypeEnum = 'D' | 'I' | 'T' | 'R' | 'C' | 'N' | 'P' | 'F' | '11184809';

export const AnswerTypeEnum = {
  D: 'D' as AnswerTypeEnum,
  I: 'I' as AnswerTypeEnum,
  T: 'T' as AnswerTypeEnum,
  R: 'R' as AnswerTypeEnum,
  C: 'C' as AnswerTypeEnum,
  N: 'N' as AnswerTypeEnum,
  P: 'P' as AnswerTypeEnum,
  F: 'F' as AnswerTypeEnum,
  UNKNOWN_DEFAULT_OPEN_API: '11184809' as AnswerTypeEnum
};
